import { createRoot } from "react-dom/client";
import { StrictMode } from "react";
import { App } from "./App";
import { BrandVariants, createDarkTheme, createLightTheme, FluentProvider, Theme } from "@fluentui/react-components";
import { BrowserRouter, Route, Routes } from "react-router";
import OuterTemplate from "./OuterTemplate";
import "./App.css";
import HomePage from "./pages/HomePage";
import HUDManagePage from "./pages/HUDManagePage";

let container = document.getElementById( "app" )!;
let root = createRoot( container );

const vorlaxion: BrandVariants = { 
  10: "#040300",
  20: "#1C1704",
  30: "#2E260B",
  40: "#3D3110",
  50: "#4C3C16",
  60: "#5D481E",
  70: "#6D5328",
  80: "#7E6034",
  90: "#8E6C43",
  100: "#9E7952",
  110: "#AE8763",
  120: "#BD9575",
  130: "#CBA488",
  140: "#D8B39C",
  150: "#E4C3B1",
  160: "#EED4C7"
};

const lightTheme: Theme = {
  ...createLightTheme( vorlaxion ), 
};

const darkTheme: Theme = {
  ...createDarkTheme( vorlaxion ), 
};

darkTheme.colorBrandForeground1 = vorlaxion[ 110 ];
darkTheme.colorBrandForeground2 = vorlaxion[ 120 ];

lightTheme.fontFamilyBase = "Inter";
darkTheme.fontFamilyBase = "Inter";

root.render(
  <FluentProvider theme={darkTheme}>
    <BrowserRouter>
      <Routes>
        <Route element={<OuterTemplate />}>
          <Route path="/hud" element={<HUDManagePage />} />
          <Route path="*" element={<HomePage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </FluentProvider>
);
